import React from "react";

import { API } from "aws-amplify";
import { useSelector } from "react-redux";

import {
  // Select, FormControl, InputLabel,
  makeStyles,
  useMediaQuery,
} from "@material-ui/core";
import SpeedIcon from "@material-ui/icons/Speed";
import classnames from "classnames";

import { useNotify, DashboardMenuItem, MenuItemLink } from "react-admin";

import {
  AccountIcon,
  CalendarIcon,
  // AuditIcon,
  CustomerIcon,
  DocumentRepoIcon,
  DocumentIcon,
  HashIcon,
  InboundIcon,
  InventoryIcon,
  InvoicesIcon,
  LogoutIcon,
  OutboundIcon,
  ProductIcon,
  ReportsIcon,
  StaffIcon,
  SubscriptionIcon,
  TaskListIcon,
  TrainIcon,
  TruckIcon,
  UserIcon,
  YardSetupIcon,
  SitIcon,
  TrackManagementIcon,
} from "../../components/common/iconography";

import { getEnv, isAuthorized, isTWA, logError } from "../../utils/appUtils";
import { sessionYardRunsDriverCheckIn } from "../../utils/gateAccess";
import { AclType, UserType } from "../../utils/constants";
import { SubMenu } from "../../components/SubMenu";
import { hasTracks } from "../../utils/locationUtils";
import { BetaBadge, NewBadge } from "../../components/common/FeatureBadges";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(2),
  },
  open: {
    width: 210,
  },
  closed: {
    width: 55,
  },
  // formControlOpen: {
  //   marginLeft: theme.spacing(2),
  //   minWidth: 192,
  // },
  // formControlClosed: {
  //   display: "none",
  // },
}));

export const ManagerMenu = ({ onMenuClick, dense }) => {
  const xsDown = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  useSelector((state) => state.theme);

  const classes = useStyles();
  const notify = useNotify();

  const showTrackManagement =
    hasTracks() && isAuthorized(AclType.TRACK_MANAGEMENT);

  // const hasSites = window.appUser?.reloadYard?.sites?.items?.length > 0;
  // const [site, setSite] = useState(getDefaultSite());
  // const getDefaultSite = () => {
  // 	const storedSite = localStorage.getItem('yardSite');
  // 	const sites = window.appUser?.reloadYard?.sites?.items;
  // 	if (storedSite) return storedSite;
  // 	if (hasSites) return sites[0];
  // 	return "";
  // }

  // const handleSiteChange = (event) => {
  // 	setSite(event.target.value);
  // 	// Additional logic for site change
  // 	try {
  // 		localStorage.setItem('yardSite', event.target.value);
  // 		window.appUser.site = event.target.value;
  // 		history.push("/");
  // 	} catch (err) {
  // 		logError("Menu:handleSiteChange", err, false);
  // 	}
  // };

  const handleSubscriptions = async () => {
    debugger;
    try {
      const cusomerId = window.appUser?.reloadYard.subscription.customerId;

      const response = await API.post(
        "transREST",
        "/stripe-create-portal-session",
        {
          body: {
            customer: cusomerId,
            return_url: window.location.href,
          },
        },
      );

      debugger;
      if (response.err)
        logError(
          "layout:Meunu:handleSubscriptions:response",
          response.err,
          notify,
        );
      else window.location.replace(response.session.url);
    } catch (error) {
      logError("layout:Meunu:handleSubscriptions", error, notify);
    }
  };

  const isStripeSubscriptinoLinkVisible = () => {
    return (
      window.appUser?.reloadYard.subscription &&
      window.appUser?.type === UserType.MANAGER &&
      !isTWA()
    );
  };

  return (
    <div
      className={classnames(classes.root, {
        [classes.open]: open,
        [classes.closed]: !open,
      })}
    >
      {" "}
      {/* {hasSites &&
				<FormControl
					className={classnames({
						[classes.formControlOpen]: open,
						[classes.formControlClosed]: !open,
					})}
				>
					<InputLabel id="site-select-label">Site</InputLabel>
					<Select
						labelId="site-select-label"
						id="site-select"
						value={site}
						onChange={handleSiteChange}
						variant="outlined"
						margin="dense"
						fullWidth
					>
						<MenuItem value="Site_1">Boston</MenuItem>
						<MenuItem value="Site_2">South Boston</MenuItem>
						<MenuItem value="Site_3">Charlestown</MenuItem>
					</Select>
				</FormControl>
			} */}
      <DashboardMenuItem
        onClick={onMenuClick}
        sidebarIsOpen={open}
        primaryText="Dashboard"
      />
      <MenuItemLink
        to={`/inboundShipments`}
        primaryText="Inbound Shipments"
        leftIcon={<InboundIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      <MenuItemLink
        to={`/outboundShipments`}
        primaryText="Outbound Shipments"
        leftIcon={<OutboundIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      {showTrackManagement && (
        <SubMenu
          name="Track Management"
          icon={<TrackManagementIcon />}
          sidebarIsOpen={open}
          defaultTo={`/trackManagementAdmin`}
          onClick={onMenuClick} // <-- and close the menu
        >
          <MenuItemLink
            to={`/trackManagementAdmin`}
            primaryText="Track Management"
            leftIcon={<TrackManagementIcon />}
            onClick={onMenuClick}
          />
          <MenuItemLink
            to="/sitList"
            primaryText="SIT Cars"
            leftIcon={<SitIcon />}
            onClick={onMenuClick}
          />
        </SubMenu>
      )}
      <SubMenu
        name="Inventory"
        icon={<InventoryIcon />}
        sidebarIsOpen={open}
        defaultTo="/inventories" // <-- click here will navigate
        onClick={onMenuClick} // <-- and close the menu
      >
        <MenuItemLink
          to="/inventories"
          primaryText="By Lot #"
          leftIcon={<HashIcon ml={1} />}
          onClick={onMenuClick}
        />
        <MenuItemLink
          to="/products"
          primaryText="By Product"
          leftIcon={<ProductIcon />}
          onClick={onMenuClick}
        />
      </SubMenu>
      {/* <MenuItemLink
				to="/audits"
				primaryText="Audit"
				leftIcon={<AuditIcon />}
				onClick={onMenuClick}
				sidebarIsOpen={open}
				dense={dense}
			/> */}
      {isAuthorized(AclType.ACCOUNTS) && (
        <SubMenu
          // name="Accounts"
          name={
            <>
              Accounts
              <NewBadge />
            </>
          }
          icon={<AccountIcon />}
          sidebarIsOpen={open}
          defaultTo="/accounts" // <-- click here will navigate
          onClick={onMenuClick} // <-- and close the menu
        >
          <MenuItemLink
            to={`/accounts`}
            primaryText="Accounts"
            // primaryText={
            //   <>
            //     Accounts
            //     <NewBadge />
            //   </>
            // }
            leftIcon={<AccountIcon />}
            onClick={onMenuClick}
          />
          <MenuItemLink
            to="/customers"
            primaryText="Customer Users"
            leftIcon={<StaffIcon />}
            onClick={onMenuClick}
          />
        </SubMenu>
      )}
      {getEnv() === "dev" && (
        <MenuItemLink
          to={`/workOrders`}
          primaryText="Work Orders"
          leftIcon={<DocumentIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      {isAuthorized(AclType.INVOICES) && (
        <MenuItemLink
          to={`/invoices`}
          primaryText="Invoices"
          leftIcon={<InvoicesIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      {isAuthorized(AclType.MY_YARD) && !isAuthorized(AclType.USERS) && (
        <MenuItemLink
          to={`/reloadYards/${window.appUser?.reloadYard.id}`}
          // primaryText="My Yard"
          primaryText={
            <>
              My Yard
              <NewBadge />
            </>
          }
          leftIcon={<YardSetupIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      {isAuthorized(AclType.MY_YARD) && isAuthorized(AclType.USERS) && (
        <SubMenu
          // name="My Yard"
          name={
            <>
              My Yard
              <NewBadge />
            </>
          }
          icon={<YardSetupIcon />}
          sidebarIsOpen={open}
          defaultTo={`/reloadYards/${window.appUser?.reloadYard.id}`} // <-- click here will navigate
          onClick={onMenuClick} // <-- and close the menu
        >
          <MenuItemLink
            to={`/reloadYards/${window.appUser?.reloadYard.id}`}
            primaryText="My Yard"
            leftIcon={<YardSetupIcon />}
            onClick={onMenuClick}
          />
          <MenuItemLink
            to="/users"
            primaryText="Users"
            leftIcon={<StaffIcon />}
            onClick={onMenuClick}
          />
        </SubMenu>
      )}
      {isAuthorized(AclType.USERS) && !isAuthorized(AclType.MY_YARD) && (
        <MenuItemLink
          to="/users"
          primaryText="Users"
          leftIcon={<StaffIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      <MenuItemLink
        to="/utilization"
        primaryText="Yard Utilization"
        leftIcon={<SpeedIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      <MenuItemLink
        to={`/files`}
        primaryText="Documents"
        leftIcon={<DocumentRepoIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      <SubMenu
        // name="Carriers"
        name={
          <>
            Carriers
            <BetaBadge />
          </>
        }
        icon={<TruckIcon />}
        sidebarIsOpen={open}
        defaultTo="/carriers" // <-- click here will navigate
        onClick={onMenuClick} // <-- and close the menu
      >
        <MenuItemLink
          to="/carriers"
          primaryText="Carriers"
          leftIcon={<TruckIcon />}
          onClick={onMenuClick}
        />
        <MenuItemLink
          to="/carrierUsers"
          primaryText="Carrier Users"
          leftIcon={<StaffIcon />}
          onClick={onMenuClick}
        />
        {isAuthorized(AclType.GATE_MANAGEMENT) &&
          sessionYardRunsDriverCheckIn() && (
            <MenuItemLink
              to="/gateQueue"
              primaryText="Gate Queue"
              leftIcon={<TruckIcon />}
              onClick={onMenuClick}
            />
          )}
      </SubMenu>
      <MenuItemLink
        to={`/tasks`}
        primaryText="Tasks"
        leftIcon={<TaskListIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      {isStripeSubscriptinoLinkVisible() && (
        <MenuItemLink
          to={false}
          primaryText="Subscriptions"
          leftIcon={<SubscriptionIcon />}
          onClick={handleSubscriptions}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      {!xsDown && (
        <MenuItemLink
          to={`/schedule`}
          primaryText="Schedule"
          leftIcon={<CalendarIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      {!xsDown && (
        <MenuItemLink
          to={`/reports`}
          primaryText="Reports"
          leftIcon={<ReportsIcon />}
          onClick={onMenuClick}
          sidebarIsOpen={open}
          dense={dense}
        />
      )}
      {xsDown && (
        <MenuItemLink
          to="/logout"
          primaryText="Logout"
          leftIcon={<LogoutIcon />}
          sidebarIsOpen={open}
        />
      )}
    </div>
  );
};
